import React from 'react';
import { connect } from 'react-redux';

import StoreComponent, { mapStateToProps } from '../../appComponents/Store';

import s from './.module.scss';

interface Props {

}

/**
 * 404
 */
class Component extends StoreComponent<Props> {
  render(): React.ReactNode {
    return (
      <div className={s.container}>
        404
      </div>
    );
  }
}

export default connect(mapStateToProps)(Component);
